/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cognito_identity_pool_id": "ap-southeast-1:8d022b68-a3d1-4da2-ad90-aee67ab2aeca",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_ncKRSzmXJ",
    "aws_user_pools_web_client_id": "kc6t7f7hage1qrff5bcv5mj19",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://wpdxil7zabcspefjibabvwdnki.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "predictions": {
        "convert": {
            "speechGenerator": {
                "region": "ap-southeast-1",
                "proxy": false,
                "defaults": {
                    "VoiceId": "Joanna",
                    "LanguageCode": "en-US"
                }
            }
        }
    }
};


export default awsmobile;
